<ly-auth>
  <form [formGroup]="signInForm" (submit)="submit()">
    <div>
      <div class="header">
        <div class="header-logo">
          <a href="https://dodd.ly" target="_blank"><ly-logo></ly-logo></a>
        </div>

        <h2>Sign in to Your Account</h2>
      </div>

      <ng-container>
        <div class="mb-2">
          <label for="email1" class="label">Email Address</label>
          <input
            id="email1"
            type="text"
            placeholder="Email address"
            pInputText
            pSize="small"
            class="w-full mb-1"
            formControlName="email"
          />
        </div>

        <label for="password1" class="label">Password</label>
        <input
          id="password1"
          type="password"
          placeholder="Password"
          pInputText
          class="w-full mb-3"
          formControlName="password"
        />

        <ly-callout
          *ngIf="invalidCredentials"
          class="mb-3"
          icon="error"
          type="negative"
        >
          Invalid login or password</ly-callout
        >

        <button
          type="submit"
          [disabled]="signInForm.invalid"
          [class.proccessing]="isProcessing"
          class="button fluid indigo icon mb-3"
        >
          Sign in
          <ly-icon size="16px" icon="arrowRight"></ly-icon>
        </button>

        <button
          type="button"
          class="button fluid indigo outlined mb-3 icon"
          (click)="signInWithGoogle()"
        >
          <ly-icon size="14px" class="mr-1" icon="google"></ly-icon>
          Sign in with Google
        </button>

        <div class="mb-3 separator">
          <span>OR</span>
        </div>

        <button
          type="button"
          routerLink="/sign-up"
          class="button outlined fluid indigo outline icon"
        >
          Create account
          <ly-icon size="16px" icon="arrowRight"></ly-icon>
        </button>
      </ng-container>
      <div class="text-center mt-3">
        <a
          routerLink="/forgot-password"
          class="text-sm hover:text-primary hover:underline hover:cursor-pointer transition duration-200"
        >
          Forgot Password?
        </a>
      </div>
    </div>
  </form>

  <div class="text-center mt-5 mb-2 terms-of-service">
    <p>By continuing, you agree to our</p>
    <p>
      <a href="https://dodd.ly/terms-of-service" target="_blank"
        >Terms of Service</a
      >
      and
      <a href="https://dodd.ly/privacy-policy" target="_blank">Privacy Policy</a
      >.
    </p>
    <p>Thrilling stuff, we know.</p>
  </div>
</ly-auth>
